var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M3.5 20.125C3.5 21.16 4.316 22 5.321 22H18.68c1.005 0 1.821-.84 1.821-1.875V9.5h-17v10.625zm2.429-7.5c0-.344.273-.625.607-.625h3.643c.333 0 .607.281.607.625v3.75c0 .344-.274.625-.607.625H6.536c-.334 0-.607-.281-.607-.625v-3.75zM18.679 4.5h-1.822V2.625c0-.344-.273-.625-.607-.625h-1.214c-.334 0-.607.281-.607.625V4.5H9.57V2.625c0-.344-.273-.625-.607-.625H7.75c-.334 0-.607.281-.607.625V4.5H5.32C4.316 4.5 3.5 5.34 3.5 6.375V8.25h17V6.375c0-1.035-.816-1.875-1.821-1.875z",
    transform: "translate(-192 -279) translate(48 279) translate(144)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarFilled);
export default __webpack_public_path__ + "static/media/calendar-filled.18985848.svg";
export { ForwardRef as ReactComponent };